// 导入必要的样式、组件和hooks
import './Dashboard.less';
import { useState, useRef, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { authService, userService } from '@/api/index';
import Icon from '@/components/iconfont/Icon.jsx';
import member from '@/assets//member-tag.png';
// import credit from '@/assets/layouts/dashboard/Credits.png';
// import discord from '@/assets/layouts/dashboard/discord.png';
// import transform from '@/assets/layouts/dashboard/transform.png';
// import select from '@/assets/layouts/dashboard/select.png';
// import logo from '@/assets/logot-v3.png';
// import avatar from '@/assets/avatar.png';
import TextureNoise from '@/assets/logo.png';
import ava from '@/assets/headimg.png';
import { useTranslation } from 'react-i18next';
// import { checkUrlLanguage } from '@/utils/i18n.ts';
// import { UseUserLevel } from '@/hooks/levelHooks.js';
// import ImgSetting from '@/assets/layouts/dashboard/home_nav_settings.svg';
export const DISCORD_URL = 'https://discord.gg/TWmQRqKN';
import Navigation from './components/Navigation/Navigation.jsx';
import { removeToken } from '@/utils/cookie.js';
import { setUserInfo } from '@/store/slices/userInfo.js';
import { setShowPricePage } from '@/store/slices/home.js';

import { useDispatch, useSelector } from 'react-redux';
import PricingPage from '@/pages/pricingPage/PricingPage.jsx';
import { reportData } from '@/utils/trackingPoint.js';
import SentryTracker from '@/utils/Sentry/sentryUtils.js';

function Dashboard() {
  // const [userData, setUserData] = useState({});
  // const userData = { avatar: avatar };
  const [dropOpen, setDropOpen] = useState(false);
  const [score, setScore] = useState(0);

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);

  const home = useSelector((state) => state.home);

  // const [languagOpen, setlanguagOpen] = useState(false);
  // const [languagType, setLanguagType] = useState(0);
  // const languageList = [
  //   { lable: 'English', code: ['en', 'en-US'] },
  //   { lable: 'Japanese', code: ['ja'] },
  //   { lable: 'Portuguese', code: ['pt', 'pt-BR'] },
  // ];

  // const [avatarLoading, setAvatarLoading] = useState(true);
  // const [avatarTimestamp, setAvatarTimestamp] = useState(new Date().getTime());
  const { t } = useTranslation();

  // 获取导航函数
  const navigate = useNavigate();

  const location = useLocation();

  const [showNavigate, setShowNavigate] = useState(true);

  useEffect(() => {
    if (
      ['/texture', '/preview', '/textureUnity'].includes(location.pathname) ||
      location.pathname.includes('/texture/') ||
      location.pathname.includes('/preview/')
    ) {
      setShowNavigate(false);
    } else {
      setShowNavigate(true);
    }
    // 你可以在这里执行任何副作用，如统计、请求等
  }, [location]);

  useEffect(() => {
    if (!['/login'].includes(location.pathname)) {
      queryUserInfo();
    }
  }, []);

  const menuRef = useRef(null);

  // const handleToDiscord = () => {
  //   window.open(DISCORD_URL, '_black');
  // };

  const queryUserInfo = async () => {
    try {
      const res = await userService.userDetail();
      if (res.code === 0) {
        dispatch(setUserInfo(res.data));
        SentryTracker.setUser({
          email: res.data.email,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleSignout = async () => {
    reportData('profile-signout');
    await authService.logout();
    removeToken();
    navigate('/login');
    window.location.reload();
  };

  // const mouseLeaveClose = () => {
  //   setDropOpen(false);
  //   setlanguagOpen(false);
  // };
  const mouseHoverShow = (event) => {
    event.stopPropagation();
    reportData('navbar-profile');
    setDropOpen(!dropOpen);
    // setlanguagOpen(false);
  };

  // const handleToSetting = () => {
  //   navigate('/settings');
  //   mouseLeaveClose();
  // };
  // const handleToLanguage = () => {
  //   const languageCode = localStorage.getItem('i18nextLng') || 'en-US';
  //   setLanguagType(languageList.findIndex((item) => item.code.includes(languageCode)));
  //   setlanguagOpen((res) => !res);
  // };
  // const changeLanguage = (index) => {
  //   const languageCode = languageList[index].code[0];
  //   checkUrlLanguage(languageCode);
  //   mouseLeaveClose();
  // };
  // const buyCredits = (type) => {
  //   localStorage.setItem('pricing_type', type);
  // };

  // useEffect(() => {
  //   if (userData?.avatar) {
  //     setAvatarTimestamp(new Date().getTime());
  //   }
  // }, [userData]);

  const getLevelStr = () => {
    // 1免费, 2:starter 月 , 4:starter 年 ,8:creater 月,16:creater 年
    if (userInfo.subscriptionId === 1) {
      return 'Standard';
    } else if (userInfo.subscriptionId === 2 || userInfo.subscriptionId === 4) {
      return 'Starter';
    } else if (userInfo.subscriptionId === 8 || userInfo.subscriptionId === 16) {
      return 'Creater';
    }
  };
  return (
    <div
      className="dashboard-layout"
      onClick={() => {
        setDropOpen(false);
      }}>
      {/* 头部 */}
      <div className="header">
        <img
          src={TextureNoise}
          onClick={() => {
            window.location.href =
              window.location.protocol +
              '//' +
              window.location.host +
              '/home?random=' +
              new Date().getTime();
            // navigate('/');
            // setTimeout(() => {
            //   window.location.reload(true);
            // });
          }}
          className="imgs"
          alt=""
        />

        {/* <div
          className="member_icon"
          onClick={() => {
            reportData('navbar-upgrade');
            dispatch(setShowPricePage(true));
          }}>
          {t('As_Home_TopNavUpgrade')}
          <img className="member_img" src={member} alt="" />
        </div> */}
        {/* 用户头像下拉菜单 */}
        <div className="dropdown dropdown-bottom dropdown-end dropdown-open" style={{ zIndex: 99 }}>
          {/*{avatarLoading ? (*/}
          {/*  <div className="skeleton shrink-0 rounded-full"></div>*/}
          {/*) : (*/}
          <img
            tabIndex={0}
            className="avatar_img"
            src={ava}
            alt=""
            onClick={(event) => mouseHoverShow(event)}
          />
          {/*)}*/}

          {dropOpen && (
            <ul
              onClick={(event) => {
                event.stopPropagation();
              }}
              tabIndex={0}
              className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow"
              ref={menuRef}>
              <div className="rashaun_box">
                <div className="title">{userInfo.username}</div>
                <div className="email">{userInfo.email}</div>
              </div>

              <div className="menus">
                {/* <div className="vip">
                  <div className="icon"></div>
                  <div className="title">{getLevelStr()}</div>
                  <div
                    className="upgrade-button"
                    onClick={() => {
                      dispatch(setShowPricePage(true));
                      setDropOpen(false);
                      reportData('profile-upgrade');
                    }}>
                    Upgrade
                  </div>
                </div> */}
                <div
                  className="settings"
                  onClick={() => {
                    navigate('/setting');
                    setDropOpen(false);
                    reportData('profile-settings');
                  }}>
                  <div className="icon"></div>
                  <div className="title">Settings</div>
                </div>
                <div className="sign-out" onClick={handleSignout}>
                  <div className="icon"></div>
                  <div className="title">Sign out</div>
                </div>
              </div>
            </ul>
          )}
        </div>
      </div>
      <div className="dashboard_box">
        {showNavigate ? <Navigation></Navigation> : <></>}
        <div className="dashboard-content scrollbar-thin scrollbar-track-transparent">
          <Outlet></Outlet>
        </div>
      </div>
      {home.showPricePage && (
        <PricingPage
          close={() => {
            dispatch(setShowPricePage(false));
          }}></PricingPage>
      )}
    </div>
  );
}

export default Dashboard;
